// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2ykSB","login-pay":"_2-niE","different-email":"cDETG","terms-conditions":"_3lzI3","social-wrapper":"_2XAn0"};